import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { acceptTermsConditionsApi, authenticateUser, toggleDarkModeApi } from '../api/userAPI';

export const authenticateUserThunk = createAsyncThunk(
  'users/authenticateUserThunk',
  async (user) => {
    const response = await authenticateUser(user);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);
export const acceptTermsConditions = createAsyncThunk(
  'users/acceptTermsConditions',
  async (payload) => {
    const response = await acceptTermsConditionsApi(payload.userEmail);
    return response;
  }
);
export const toggleDarkMode = createAsyncThunk(
  'users/toggleDarkMode',
  async (payload) => {
    const response = await toggleDarkModeApi(payload.userEmail, payload.darkMode);
    if (response) return payload.darkMode;
  }
);

export const userSlice = createSlice({
  name: 'user',
  initialState: {value: null},
  reducers: {
    
    updateUser: (state, action) => {
      state.value = action.payload
    },
    createUser: (state, action) => {
      state.value = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authenticateUserThunk.fulfilled, (state, action) => {
      state.value = action.payload;
    });
    builder.addCase(acceptTermsConditions.fulfilled, (state, action) => {
      state.value = action.payload;
    });
    builder.addCase(toggleDarkMode.fulfilled, (state, action) => {
      state.value.darkMode = action.payload;
    });
  },
})

export const { updateUser } = userSlice.actions;

export const selectUser = (state) => state.user;

export default userSlice.reducer;